var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-content',[_c(_setup.ControlPanel),(_setup.network !== null && _setup.slicedNetwork)?_c(_setup.EdgeSlices):_vm._e(),(_setup.network !== null)?_c(_setup.MultiMatrix):_vm._e(),(_setup.loadError.message !== '')?_c(_setup.AlertBanner):_vm._e()],1),(_setup.showProvenanceVis)?_c(_setup.ProvVis):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }